/* eslint-disable import/no-anonymous-default-export */
import { ENV } from "../config";
export default {
  API_URL: ENV.API.URL,
  API_BASE_URL: ENV.API.BASE_URL,
  API_HEADER_KEY: ENV.API.HEADER_KEY,
  API_HEADER_VALUE: ENV.API.HESDER_VALUE,
  GOOGLE_KEY: ENV.KEYS.GOOGLE,
  PYTHON_API_URL: ENV.PYTHON_API,
  INQUIRY_API_KEY: ENV.INQUIRY_API_KEY,
  INQUIRY_ORIGIN: ENV.INQUIRY_ORIGIN,
};
